import React from 'react';

export default class StepInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(e) {
    this.props.setNumberOfItems(this.props.parseCounter(e.target.value));
  }

  componentDidMount() {
    if (this.props.focusCounter === true) {
      const tempValue = this.stepCounter.value;
      this.stepCounter.value = '';
      this.stepCounter.value = Number(tempValue);
      this.stepCounter.focus();
    }
  }

  render() {
    const count = this.props.parseCounter(this.props.numberofItems);
    return (
      <div className="inline">
        <input
          className="stepperNumber no-selection olo-client-theme-border olo-client-theme-color"
          type="text"
          onChange={this.handleOnChange}
          value={count}
          ref={input => {
            this.stepCounter = input;
          }}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/StepInput.jsx